import { vsprintf } from 'sprintf-js';
import axios from 'axios';
import enpoints from '../../../config/endpoints';

class Logger {
	constructor({ name, message }) {
		this.name = name;
		this.message = message;
		this.data = new Map();
		this.cache = new Map();

		this.readyToRequest = false;

		// @todo if browser timer was loser use recursive setTimeout method
		this.interval = setInterval(this.interval.bind(this), 2000);
	}

	add(...args) {
		const key = args.join(',');
		const value = vsprintf(this.message, args);

		if (!this.cache.has(key)) {
			this.data.set(key, value);
			this.cache.set(key, value);
		}

		this.setReadyToRequest(false);
	}

	interval() {
		const shouldSend = this.readyToRequest && this.data.size > 0;

		if (shouldSend) {
			const data = [];

			this.data.forEach(entity => data.push(entity));
			this.data.clear();

			axios.post(`/${enpoints.APP.LOGGER}`, { name: this.name, data});
		}

		this.setReadyToRequest(!shouldSend);
	}

	setReadyToRequest(value) {
		this.readyToRequest = value;
	}
}

export default Logger;


// WEBPACK FOOTER //
// ./frontend/cabinets/modules/shared/logger/index.js